import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms";

export function isNumberValidator (): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const str = control.value;
    if (str === null || str === undefined || str === "") {
      return null;
    }
    if (!isNaN(str) && !isNaN(Number.parseFloat(str))) {
      return null;
    }

    return { "isNumber": { "value": false } };
  };
}
